export const permissionsSubscriptionsReadonly = [
  "subscriptions-full",
  "subscriptions-readonly",
  "everything-full",
  "everything-readonly",
];
